export default {
  status: {
    completed: 'Completed',
    pending: 'Pending',
    rejected: {
      action: 'Reject',
      state: 'Rejected',
    },
    doing: 'In progress',
    revoked: {
      state: 'Revoked',
      action: 'Revoke',
    },
    unpaid: 'Unpaid',
    paid: 'Paid',
    fail: 'Payment Failed',
  },
  list: {
    revoked: 'Revoked',
  },
  '3dmodel': {
    title: 'Processing 3D Model (Beta)',
    handle: 'Processing 3D Model',
    dialog: {
      modelManage: 'Model Work Order Management',
      serviceExplain: 'Service Description',
      submit: 'Submit model processing request.',
      confirm: 'Confirm',
      resubmit: 'Re-upload',
      success:
        'Your request has been successfully submitted. We will respond with the delivery time within one business day. You can check the detailed progress in "My Assets - 3D Model Orders." If you have any questions, please contact us at support@mindworks-creative.com.',
    },
    tips: {
      upload:
        "*Please upload your model, and our team will process it according to the platform's specifications and requirements to ensure compatibility and optimal performance. We will reply with the estimated delivery time within 1 business day after you submit the model. You can check it under Creative Assets - 3D Model Order.",
      credits:
        'Model processing requires {count} points (remaining {balance} points).',
      money: 'Model processing will consume {count} (Remaining {balance})',
      videoSubmit:
        'Model processing requires {count} points (remaining {balance} points). Are you sure you want to proceed? We will reply with the estimated delivery time within 1 business day after you submit the model. You can check it under My Assets - 3D Model Order.',
      moneySubmit:
        'Model processing will consume $ {count} (Remaining $ {balance}). Are you sure you want to submit? Within 1 business day after you submit your model, we will reply with the estimated delivery time. You can view this in My Assets - 3D Model Work Order.',
      moneyTooltip:
        'When the work order is delivered, the balance will be deducted and debited.',
      remark: 'Please enter a note.',
      revoke: 'Are you sure you want to revoke this 3D model order?',
    },
    uploader: {
      require:
        'Please drag and drop or upload a ZIP file. The ZIP package must contain only the following file types: Model files: .fbx, .ma, .mb, .max, .glb, .gltf (with .bin). Texture files: .png, .jpg.',
      format: 'Format',
      require1: 'Triangle count < 10,000, Vertex count < 8,000, Mesh = 1',
      require2: 'Number of textures >= 1',
      nosupportFormat: 'Unsupported file format',
      missModelFile: 'Missing model file',
      warning: {
        triangles: 'Triangle count < 10,000',
        vertex: 'Vertex count < 8,000',
        mesh: 'Mesh = 1',
        contentError: 'File content error.',
        picCountError: 'File content error. Requires at least 1 texture.',
      },
    },
    service: 'Model Processing Service (Beta)',
    tip: "We provide 3D model processing services according to the platform's specifications and requirements to ensure the model can be used in the General Feature Changer.",
  },
  name: 'Work order',
  table: {
    column: {
      remark: 'Note',
      status: 'Status',
      relativeProject: 'Associated Project',
      estimatedDeliverTime2: 'Estimated Delivery Time',
      deliverTime: 'Actual Delivery Time',
      categoryName: 'Slot Name',
      createdTime: 'Creation time',
      usageType: 'Payment Type',
      balance: 'Balance',
      videoCredits: 'Point',
      deduction: 'Deduction Count',
      count: '{count} Point',
    },
  },
  filter: {
    modelName: 'Model Name',
    orderId: 'Order ID',
    statusOptions: 'Select Status',
    '3dmodel': '3D Model',
  },
}
